import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/service/http/http.service';
import { BatchExecutionsResponse } from '../models/batch-execution.model';

@Injectable({
  providedIn: 'root',
})
export class MonitoramentoService {
  private readonly httpService = inject(HttpService);

  getBatchExecutions(): Observable<BatchExecutionsResponse> {
    return this.httpService.genericGet<BatchExecutionsResponse>('jobs/batch-executions');
  }
}
